var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_1583)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.26,
    height: 42.26,
    transform: "translate(0.972473)",
    fill: "#010938"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79774 32.4478C8.77042 32.4478 7.85695 33.089 7.45744 33.7162C7.22894 32.9609 6.60111 32.4478 5.57381 32.4478C4.53209 32.4478 3.61874 33.1317 3.33343 33.5595V32.6189L1.83493 32.6188V39.502H3.33349V34.6995C3.64731 34.2434 4.26088 33.7729 4.9174 33.7729C5.73066 33.7729 6.05903 34.2717 6.05903 35.013V39.5018H7.55738V34.6851C7.85695 34.2434 8.48474 33.7729 9.15567 33.7729C9.95468 33.7729 10.2829 34.2717 10.2829 35.013V39.5018H11.7813V34.5283C11.7811 33.1317 11.0677 32.4478 9.79774 32.4478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8332 38.3475C15.5631 38.3475 14.8495 37.2783 14.8495 36.053C14.8495 34.8417 15.5628 33.7729 16.8332 33.7729C18.1173 33.7729 18.8308 34.8417 18.8308 36.053C18.8308 37.2783 18.1173 38.3475 16.8332 38.3475ZM16.8332 32.4474C14.6498 32.4474 13.2942 34.0863 13.2942 36.053C13.2942 38.0341 14.6498 39.6729 16.8332 39.6729C19.0447 39.6729 20.3867 38.034 20.3867 36.053C20.3864 34.0863 19.0447 32.4474 16.8332 32.4474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4534 35.3121C23.6397 35.127 22.9549 34.9845 22.9549 34.4856C22.9549 34.0009 23.4544 33.6448 24.2391 33.6448C25.0954 33.6448 25.8663 34.0009 26.2795 34.4713L26.9075 33.4166C26.2795 32.8608 25.3949 32.4478 24.2246 32.4478C22.4836 32.4478 21.5134 33.4166 21.5134 34.5424C21.5134 36.0817 22.9264 36.3952 24.1103 36.6516C24.9522 36.837 25.68 36.9939 25.68 37.5636C25.68 38.1052 25.2233 38.4898 24.3245 38.4898C23.4251 38.4898 22.4694 38.0199 21.984 37.5207L21.2992 38.6037C22.0126 39.3019 23.083 39.6729 24.2533 39.6729C26.1085 39.6729 27.1215 38.7466 27.1215 37.5352C27.1218 35.9107 25.6519 35.5686 24.4534 35.3121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4048 37.6632C28.8626 37.6632 28.4059 38.1193 28.4059 38.6607C28.4059 39.202 28.8628 39.6582 29.4048 39.6582C29.9471 39.6582 30.4037 39.202 30.4037 38.6607C30.4037 38.1193 29.9471 37.6632 29.4048 37.6632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.629 33.6306V32.6186H32.1306V39.5019L33.629 39.502V34.8134C33.9288 34.3287 34.7707 33.9013 35.3987 33.9013C35.5839 33.9013 35.741 33.9154 35.8694 33.9441V32.4621C34.9702 32.4621 34.1428 32.9749 33.629 33.6306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7341 32.6186V37.4497C41.3773 37.9197 40.7207 38.3475 39.9644 38.3475C39.1224 38.3475 38.5802 38.0198 38.5802 36.9509V32.6186H37.0817V37.4926C37.0817 38.9033 37.8097 39.6729 39.2936 39.6729C40.378 39.6729 41.2345 39.1456 41.7337 38.5899V39.502L43.2324 39.5019V32.6186H41.7341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7104 3.69836H31.357V22.3595C31.357 22.793 31.0037 23.1459 30.5695 23.1459H28.2965C26.1104 23.1459 24.2232 23.5071 22.1141 25.8136L22.1057 23.1459H14.4979C14.0638 23.1459 13.7104 22.7931 13.7104 22.3595L13.7104 3.69836ZM12.1875 22.3595C12.1875 23.6319 13.224 24.6668 14.4979 24.6668H20.8332V28.937L22.2321 27.4639C24.2275 25.3989 25.8146 24.6668 28.2965 24.6668H30.5695C31.8435 24.6668 32.8799 23.6319 32.8799 22.3595V2.17747H12.1875V22.3595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.26,
    height: 42.26,
    fill: "white",
    transform: "translate(0.972473)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG4);
export default __webpack_public_path__ + "static/media/g4.0a310a40cb480fcbdbebc58200d9b0ba.svg";
export { ForwardRef as ReactComponent };